// sentryManager.ts
import * as Sentry from '@sentry/react';

import config from "../config/config.ts";
import { sentryBeforeSend } from "./sentryBeforeSend.ts";

declare global {
    interface Window {
        __SENTRY_INITIALIZED__?: boolean;
    }
}

export const initializeSentry = () => {
    if (!window.__SENTRY_INITIALIZED__) {
        Sentry.init({
            dsn: config.sentryDsn,
            beforeSend: sentryBeforeSend,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
                Sentry.consoleLoggingIntegration({ levels: ["error", "warn"] }),
                Sentry.feedbackIntegration({
                    showDialog: false,
                    hideFeedbackButtons: true
                })
            ],
            _experiments: { enableLogs: true },
            environment: config.environment,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            tracesSampleRate: 1.0,
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/sellersdirect\.com/,
                /^https:\/\/staging\.sellersdirect\.com/,
                /^https:\/\/clients\.direct/,
                /^https:\/\/staging\.clients\.direct/,
                /^https:\/\/clients-direct\.com/,
                /^https:\/\/staging\.clients-direct\.com/],
        });
        window.__SENTRY_INITIALIZED__ = true;
    }
};